import { combineReducers } from 'redux';

import accountsReducer from './accounts/data/reducer';

const reducer = combineReducers({
  accounts: accountsReducer,
});

export { reducer };
